import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import { useParams } from "react-router-dom";
import { useGetFourWeekPlanFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { useTranslation } from "react-i18next";
import { DailyProgress } from "./components/DailyProgress";
import { TrackerCard } from "UIPalette/TrackerCard/TrackerCard";
import { LearningMaterials } from "UIPalette/LearningMaterials/LearningMaterials";
import { ViewStateWrapper } from "UIPalette/ViewStateWrapper/ViewStateWrapper";
import { NotFound } from "../../NotFound";
import { datocmsUUIDRegex } from "shared/utils/regex";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { Column, Row } from "shared/UI/LayoutComponents/LayoutComponents";

export const ViewFourWeekPlan = () => {
  const { fourWeekPlanId } = useParams();
  const isValidFourWeekPlanId = fourWeekPlanId !== undefined && datocmsUUIDRegex.test(fourWeekPlanId);
  const { t } = useTranslation();
  const {
    data: fourWeekPlan,
    isLoading,
    error,
    mutate,
  } = useGetFourWeekPlanFunctionRequest(
    { id: fourWeekPlanId },
    { revalidateOnMountIfStale: false, showErrorIfStale: false, shouldFetch: isValidFourWeekPlanId }
  );

  if (!isValidFourWeekPlanId) {
    return <NotFound />;
  }

  return (
    <>
      <PageTitle title={t("pageTitle.resources.fourWeekPlans.fourWeekPlanId", { fourWeekPlanId: fourWeekPlan?.name })} />
      <PageHeader title={fourWeekPlan?.name!} />
      <ViewStateWrapper loading={isLoading} error={!!error} errorMessage={t("fourWeekPlans.singleError")} onRetry={mutate}>
        <Row>
          <Column>
            <p>{fourWeekPlan?.description}</p>
            <DailyProgress fourWeekPlanId={fourWeekPlanId!} />
            {fourWeekPlan?.trackers?.map((tracker) => {
              return <TrackerCard key={tracker.id} tracker={tracker} />;
            })}
          </Column>
          {fourWeekPlan?.categories && fourWeekPlan?.categories.length > 0 && (
            <Column>
              <div className="space-y-2">
                <h2 className={"p-0"}>{t("fourWeekPlans.usefulArticles")}</h2>
                <LearningMaterials
                  categoryIds={fourWeekPlan?.categories.map((category) => category.id)!}
                  errorMessage={t("fourWeekPlans.articlesErrorButton")}
                  ariaLabel={t("fourWeekPlans.articles")}
                />
              </div>
            </Column>
          )}
        </Row>
      </ViewStateWrapper>
    </>
  );
};
